<div *ngIf="state$ | async; let state" class="zas-width">
    <h1>
        Administrationsansicht
        <span class="header-version">{{ buildVersion }}</span>
        <div *ngIf="!zbdGlobals.embedded" class="main-menu-container">
            <zbd-main-menu>
                <li>
                    <a [routerLink]="['..']">
                        <span class="icon-link prefix-icon"></span
                        >&nbsp;Benutzeransicht
                    </a>
                </li>
            </zbd-main-menu>
        </div>
    </h1>
    <ng-container *ngFor="let offer of state.cp.Protocol.Offers">
        <zbd-simple-toggle
            *ngFor="let div of offer.Divisions"
            [title]="getTitle(state.cp, offer, div)"
        >
            <div class="division">
                <h2>Events</h2>
                <table class="event-table table">
                    <thead>
                        <tr>
                            <th>Gebiet</th>
                            <th>Feld</th>
                            <th>Wert</th>
                            <th>Alter Wert</th>
                            <th>Ereignis</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let ev of div.Events">
                            <td>{{ ev.Area }}</td>
                            <td>{{ ev.Field }}</td>
                            <td>{{ ev.NewValue }}</td>
                            <td>{{ ev.OldValue }}</td>
                            <td>{{ ev.EventName }}</td>
                        </tr>
                    </tbody>
                </table>
                <h2>Variablen</h2>
                <table class="vars-table table table-condensed table-striped">
                    <thead>
                        <tr>
                            <th>Variable</th>
                            <th>Wert</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let val of getVars(div.TextblockEnv)">
                            <td>{{ val.key }}</td>
                            <td [ngClass]="valueClassSelector(val.value)">
                                {{ val.value }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </zbd-simple-toggle>
    </ng-container>
</div>
